module.exports = __webpack_public_path__ + "img/boom_csboomcsboom.e54379c.png";